const HeroSection = () => (
  <div className="hero-section">
    <div className="container-hero">
      <h1 className="hero-section__title">Ligue 1 Teams</h1>
    </div>
  </div>
);

export default HeroSection;
